
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CanonicalUrlService {

  constructor(@Inject(DOCUMENT) private dom: any) { }

  setCanonicalURL(url?: string) {
    let canURL = url == undefined ? this.dom.URL : url;
    let link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', canURL);
  }
}
